import { nextTick } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-98720be2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "default-detail"
};
const _hoisted_2 = {
  class: "field-label"
};
const _hoisted_3 = {
  class: "field-value"
};
const _hoisted_4 = {
  class: "product-item"
};
const _hoisted_5 = {
  class: "product-info"
};
const _hoisted_6 = {
  class: "product-label"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "right_icon_wrapper"
};
const _hoisted_10 = {
  class: "selected_icon"
};
const _hoisted_11 = ["onMousedown"];
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end",
    "padding": "6px"
  }
};
import { addCollectFetch, removeCollectFetch } from '@/api/payManage/appManage';
import { ref, watch } from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { message } from 'ant-design-vue';
import { OK, reportEvent } from '@/common';
import { DynamicMultipleVirtualScrollSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMultipleProductSelect',
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    showCollect: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    showSelectAll: {
      type: Boolean,
      default: true
    },
    remoteSearch: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    showPrincipalUserName: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: Number,
      default: 1
    },
    descriptionField: {
      type: String,
      default: 'filePath'
    },
    collectField: {
      type: String,
      default: 'hasFavorite'
    },
    labelField: {
      type: String,
      default: 'label'
    },
    valueField: {
      type: [String, Number],
      default: 'dbtId'
    },
    width: {
      type: [String, Number],
      default: '240px'
    },
    itemHeight: {
      type: Number
    },
    dropdownMaxHeight: {
      type: Number,
      default: 300
    },
    placeholder: {
      type: String,
      default: '请选择产品(可通过名称、ID、包名进行查询)'
    },
    value: {
      type: Array,
      default: () => []
    },
    detailFields: {
      type: Array,
      default: () => [{
        key: 'productName',
        label: '所属项目'
      }, {
        key: 'appName',
        label: '产品名'
      }, {
        key: 'pubStatus',
        label: '状态'
      }, {
        key: 'publishPlatformName',
        label: '市场'
      }, {
        key: 'productGroupName',
        label: '工作室'
      }, {
        key: 'principalUserName',
        label: '负责人'
      }, {
        key: 'filePath',
        label: '商店名'
      }]
    },
    searchFields: {
      type: Array,
      default: () => ['dbtId', 'appName', 'pkg', 'appleId', 'filePath']
    },
    getPopupContainer: {
      type: Function,
      default: undefined
    },
    setCollectAddFetch: {
      type: Function,
      default: () => addCollectFetch
    },
    setCollectCancelFetch: {
      type: Function,
      default: () => removeCollectFetch
    }
  },
  emits: ['update:value', 'onSelect', 'onChange', 'onFocus', 'onConfirm', 'onSearch'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const choosedIdList = ref([]);
    //保存初始选中状态
    const initialSelected = ref([]);
    const multiProductSelectRef = ref(null);
    const handleSelect = (e, option) => {
      choosedIdList.value = e;
      emit('onSelect', option, e);
    };
    // 点击输入框里面的叉叉取消选中的项
    const handleDeselect = e => {
      if (e) {
        choosedIdList.value = choosedIdList.value.filter(item => item !== e);
        emit('update:value', choosedIdList.value);
        emit('onChange', choosedIdList.value);
      }
    };
    const handleChange = e => {
      choosedIdList.value = e;
      emit('update:value', choosedIdList.value);
      emit('onChange', e);
    };
    const handleFocus = () => {
      emit('onFocus');
    };
    const handleSearch = value => {
      emit('onSearch', value);
    };
    const handleCollect = async (isCollected, option) => {
      try {
        const fetchMethod = isCollected ? props.setCollectCancelFetch : props.setCollectAddFetch;
        if (!fetchMethod) {
          throw new Error('收藏方法未定义');
        }
        const {
          code
        } = await fetchMethod()({
          dbtId: option.value
        });
        if (code === OK) {
          message.success(`${isCollected ? '取消收藏' : '收藏'}成功`);
          option[props.collectField] = !isCollected;
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '产品管理',
              element_name: `产品${isCollected ? '取消收藏' : '收藏'}`
            }
          });
        } else {
          throw new Error(`${isCollected ? '取消收藏' : '收藏'}失败`);
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
        message.error('操作失败，请稍后重试');
      }
    };
    const cancle = () => {
      choosedIdList.value = [...initialSelected.value];
      closeDropdown();
    };
    const confirm = () => {
      emit('onConfirm', choosedIdList.value);
      closeDropdown();
    };
    /**
     * 关闭下拉框
     */
    const closeDropdown = () => {
      var _multiProductSelectRe;
      (_multiProductSelectRe = multiProductSelectRef.value) === null || _multiProductSelectRe === void 0 || _multiProductSelectRe.closeDropdown();
    };
    const isSelected = item => {
      return choosedIdList.value.includes(item[props.valueField]);
    };
    watch(() => props.value, newVal => {
      if (newVal) {
        choosedIdList.value = newVal;
        initialSelected.value = [...newVal];
      }
    }, {
      immediate: true
    });
    watch(() => props.productList, newVal => {
      if (newVal) {
        nextTick(() => {
          multiProductSelectRef.value.displayOptions = newVal.map(item => ({
            ...item,
            label: item[props.labelField],
            value: item[props.valueField],
            height: item[props.descriptionField] ? 52 : 32
          }));
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["product_multi_select_wrap flex", {
          fewTag: __props.maxTagCount <= 1
        }])
      }, [_createVNode(_unref(DynamicMultipleVirtualScrollSelect), {
        ref_key: "multiProductSelectRef",
        ref: multiProductSelectRef,
        "popup-class-name": "custom-product-select-popup",
        modelValue: choosedIdList.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => choosedIdList.value = $event),
        placeholder: __props.placeholder,
        width: __props.width,
        allowClear: __props.allowClear,
        disabled: __props.disabled,
        showArrow: "",
        labelField: __props.labelField,
        valueField: __props.valueField,
        showDetail: __props.showDetail,
        maxTagCount: __props.maxTagCount,
        showSelectAll: __props.showSelectAll,
        remoteSearch: __props.remoteSearch,
        detailFields: __props.detailFields,
        itemHeight: __props.itemHeight,
        searchFields: __props.searchFields,
        dropdownMaxHeight: __props.dropdownMaxHeight,
        getPopupContainer: __props.getPopupContainer,
        onSelect: handleSelect,
        onSearch: handleSearch,
        onChange: handleChange,
        onOnfocus: handleFocus,
        onDeselect: handleDeselect
      }, _createSlots({
        detail: _withCtx(({
          detail,
          fields
        }) => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, field => {
          return _openBlock(), _createElementBlock("div", {
            key: field.key,
            class: "field-item"
          }, [_createElementVNode("div", _hoisted_2, _toDisplayString(field.label), 1), _createElementVNode("div", _hoisted_3, _toDisplayString((detail === null || detail === void 0 ? void 0 : detail[field.key]) || '--'), 1)]);
        }), 128))])]),
        "product-item": _withCtx(({
          item
        }) => [_createElementVNode("div", {
          class: "item-wrapper",
          style: _normalizeStyle({
            height: item.height + 'px'
          })
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          class: "ellipsis",
          title: item[__props.labelField]
        }, _toDisplayString(item[__props.labelField]), 9, _hoisted_7), _withDirectives(_createElementVNode("span", null, "（" + _toDisplayString(item.principalUserName) + "）", 513), [[_vShow, __props.showPrincipalUserName && item.principalUserName]])]), _createElementVNode("div", {
          class: "ellipsis product-des",
          title: item[__props.descriptionField]
        }, _toDisplayString(item[__props.descriptionField]), 9, _hoisted_8)])]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("div", _hoisted_10, [_createVNode(_unref(CheckOutlined))], 512), [[_vShow, isSelected(item)]]), __props.showCollect ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onMousedown: _withModifiers($event => handleCollect(item[__props.collectField], item), ["stop"]),
          class: "collect_icon"
        }, [_createVNode(SvgIcon, {
          iconClass: item[__props.collectField] ? 'collectIcon' : 'collectGreyIcon',
          class: "title-svg",
          style: {
            "margin": "0"
          }
        }, null, 8, ["iconClass"])], 40, _hoisted_11)) : _createCommentVNode("", true)])], 4)]),
        _: 2
      }, [__props.showFooter ? {
        name: "dropdown-footer",
        fn: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_button, {
          onClick: _withModifiers(cancle, ["stop"]),
          size: "small",
          style: {
            "margin-right": "12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_a_button, {
          onClick: _withModifiers(confirm, ["stop"]),
          size: "small",
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["onClick"])])]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "placeholder", "width", "allowClear", "disabled", "labelField", "valueField", "showDetail", "maxTagCount", "showSelectAll", "remoteSearch", "detailFields", "itemHeight", "searchFields", "dropdownMaxHeight", "getPopupContainer"])], 2);
    };
  }
});